import {useTranslation} from "react-i18next";
import React from "react";

const SupportBlock = ({ title, description, banner }: { title?: string; description?: string; banner?: any }) => {
    const { t } = useTranslation();
    // Helper to get the best image url
    let imgUrl = '';
    if (banner) {
        if (typeof banner === 'string') imgUrl = banner;
        else if (banner.formats?.thumbnail?.url) imgUrl = banner.formats.thumbnail.url;
        else if (banner.formats?.small?.url) imgUrl = banner.formats.small.url;
        else if (banner.formats?.medium?.url) imgUrl = banner.formats.medium.url;
        else if (banner.formats?.large?.url) imgUrl = banner.formats.large.url;
        else if (banner.url) imgUrl = banner.url;
    }
    return (
        <div className="support-guarantee-block">
            {imgUrl && <img src={imgUrl} alt={title} className="support-guarantee-img" />}
            <div className="support-guarantee-title">{title || t('subscription.supportGuarantee')}</div>
            <div className="support-guarantee-desc">{description || t('subscription.neverAlone')}</div>
        </div>
    );
};

export default SupportBlock
